
import { z } from "zod";

export const PreferredLanguageValues = ["ENGLISH", "SPANISH"] as const;
export const PreferredLanguageSchema = /* @__PURE__ */ z.enum(PreferredLanguageValues);
export const PreferredLanguage: (typeof PreferredLanguageSchema)["enum"] = { "ENGLISH": "ENGLISH", "SPANISH": "SPANISH" };
export type PreferredLanguage = (typeof PreferredLanguageValues)[number];
export const PreferredLanguageDisplayNames = { "ENGLISH": "English",
"SPANISH": "Spanish", } satisfies Record<PreferredLanguage, string>;
